export default `
    <div class="pane-row container">
        <div class="alert alert-#= data.alertType # mar-l-10 mar-r-10">
            <span class="alert-header bind-label"
                # if (data.header) { # data-bind="text: #= data.header #" # } #
            ></span>
            <span class="alert-message bind-label"
                # if (data.message) { # data-bind="text: #= data.message #" # } #
            ></span>
        </div>
    </div>
`;
